import type { Breadcrumb } from 'types/capi/shared';

type Props = {
  breadcrumbs: Breadcrumb[];
  onCrumbClick?: (breadcrumb: Breadcrumb, position: number) => void;
};

const BreadcrumbItem = ({
  breadcrumb,
  includeSeparator,
  onClick
}: {
  breadcrumb: Breadcrumb;
  includeSeparator: boolean;
  onClick?: () => void;
}) => {
  return (
    <li data-cy="breadcrumb" className="text-caption-grey">
      {includeSeparator ? <span className="px-3">•</span> : ''}
      <a href={breadcrumb.path} onClick={onClick}>
        {breadcrumb.label}
      </a>
    </li>
  );
};

const Breadcrumbs = ({ breadcrumbs, onCrumbClick }: Props) => {
  return (
    <nav>
      <ul className="flex">
        {breadcrumbs.map((breadcrumb, i) => (
          <BreadcrumbItem
            data-cy={`breadcrumb:${i}`}
            key={breadcrumb.path}
            breadcrumb={breadcrumb}
            includeSeparator={i > 0}
            onClick={
              onCrumbClick ? () => onCrumbClick(breadcrumb, i + 1) : undefined
            }
          />
        ))}
      </ul>
    </nav>
  );
};

export default Breadcrumbs;
